<template>
  <ScratchcardInfoModal
    :headline="$t('scratchcard.order.infobutton.inprogress.headline')"
    :tracking="{ topicKey: 'scratchcard-inprogress-details-modal' }"
  >
    <section class="flex flex-col gap-200">
      <p>
        {{ $t('scratchcard.order.infobutton.inprogress.description') }}
      </p>

      <div class="bg-secondary-secondary rounded-s flex flex-col items-center">
        <Illustration
          :alt="$t('scratchcard.order.infobutton.inprogress.illustration.alt')"
          :aspect-ratio="0"
          name="scratching-in-progress"
        />
      </div>

      <ScratchcardListItem
        class="bg-secondary-secondary rounded-m p-100"
        :label="$t('scratchcard.order.infobutton.inprogress.label.serialnumber')"
      >
        {{ serialNumber }}
      </ScratchcardListItem>
    </section>
  </ScratchcardInfoModal>
</template>

<script lang="ts" setup>
type ScratchcardButtonInfoInProgressProps = { serialNumber: string }

defineProps<ScratchcardButtonInfoInProgressProps>()
</script>
